import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldviewRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-fieldview',
	path: '/secure/admin/ViewIssueFields.jspa',
};
